import React from 'react';
import { isEqual } from 'lodash';
import CSPSquareCard from './csp_square_card';

import { trackEvent } from '@reverbdotcom/commons/src/elog/mparticle_tracker';
import { MParticleEvent } from '@reverbdotcom/commons/src/elog/mparticle_types';
import OverflowingRow from '@reverbdotcom/commons/src/components/overflowing_row';
import Tiles from '@reverbdotcom/commons/src/components/tiles';

import CSP from './comparison_shopping_page';
import { conditionFilter } from './condition_filter';

interface Props {
  pages?: CSP[];
  title?: JSX.Element | string;
  action?: JSX.Element;
  loaded: boolean;
  condition?: string[];
  trackName?: string;
  trackContext?: object;
  mParticleView?: MParticleEvent;
  centeredTitle?: boolean;
  stripBrandFromTitle?: boolean;
  fourWideMax?: boolean;
  expectedCount?: number;
  hideMetadata?: boolean;
}

export const SIMILAR_CSPS = 'SimilarCSPs';

class CSPSquareRow extends React.Component<Props> {
  static get defaultProps(): Partial<Props> {
    return {
      pages: [],
      trackName: 'CSPSquareRow',
      trackContext: {},
      expectedCount: 4,
    };
  }

  componentDidMount() {
    this.trackImpressions();
  }

  componentDidUpdate(prevProps) {
    if (isEqual(this.props.pages, prevProps.pages)) {
      return;
    }

    this.trackImpressions();
  }

  trackImpressions() {
    if (!this.hasPages()) {
      return;
    }

    if (this.props.mParticleView) {
      trackEvent(this.props.mParticleView);
    }
  }

  hasPages() {
    return this.props.pages.length > 0;
  }

  renderCards() {
    return (
      <Tiles
        placeholder={<CSPSquareCard />}
        loading={!this.props.loaded}
        expectedCount={this.props.expectedCount}
        fourWideMax={this.props.fourWideMax}
        singleRow
        largeTiles
        grow
      >
        {this.props.pages.map((page, idx) => (
          <CSPSquareCard
            page={page}
            key={page.id}
            position={idx}
            trackName={this.props.trackName}
            stripBrandFromTitle={this.props.stripBrandFromTitle}
            conditionFilter={conditionFilter(this.props.condition)}
            hideMetadata={this.props.hideMetadata}
            renderAsHorizontal={this.props.pages.length < 4}
          />
        ))}
      </Tiles>
    );
  }

  render() {
    if (this.props.loaded && !this.hasPages()) {
      return null;
    }

    return (
      <OverflowingRow
        title={this.props.title}
        action={this.props.action}
        centeredTitle={this.props.centeredTitle}
        collectionCount={this.props.pages.length}
      >
        {this.renderCards()}
      </OverflowingRow>
    );
  }
}

export default CSPSquareRow;
